// Lazy load function
const lazyLoad = (path) => () => import(/* webpackChunkName: "[request]" */ `@/views/${path}.vue`);

export default [
    {
        path: "/call-schedule",
        name: "call-schedule",
        meta: { requiresAuth: true, applicationFeatureCode: "CallSchedules" },
        components: {
            content: lazyLoad('customers/call-schedule'),
        },
    },
    {
        path: "/call-schedule-call-logs",
        name: "call-schedule-call-log-list",
        meta: { requiresAuth: true, applicationFeatureCode: "CallLogs" },
        components: {
            content: lazyLoad('customers/call-schedule-call-log-list'),
        },
    },
    {
        path: "/call-schedule-surveys",
        name: "call-schedule-survey-list",
        meta: { requiresAuth: true, applicationFeatureCode: "SurveyResponse" },
        components: {
            content: lazyLoad('customers/call-schedule-survey-list'),
        },
    },
]; 